import { render, staticRenderFns } from "./excel-logo.vue?vue&type=template&id=4fce5a9e&"
import script from "./excel-logo.vue?vue&type=script&lang=js&"
export * from "./excel-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fce5a9e')) {
      api.createRecord('4fce5a9e', component.options)
    } else {
      api.reload('4fce5a9e', component.options)
    }
    module.hot.accept("./excel-logo.vue?vue&type=template&id=4fce5a9e&", function () {
      api.rerender('4fce5a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/excel-logo.vue"
export default component.exports